// kanaToRomaji writes the Hepburn apostrophe after ん before a vowel or y-sound
// ("hon'yaku", "gen'in"). Learners type that apostrophe inconsistently (many
// leave it out, phone keyboards produce a curly one), so wherever romaji is
// compared with, or searched by, what a learner typed, both sides are passed
// through this first and the apostrophe never decides the result.
//
// Kept in its own module rather than next to kanaToRomaji: several test files
// replace "./kanaToRomaji" with a one-function mock.
const ROMAJI_APOSTROPHES = /['’‘ʼ`´]/g;

export function stripRomajiApostrophes(text: string): string {
    return text.replace(ROMAJI_APOSTROPHES, "");
}
